module.exports = __webpack_public_path__ + "img/locationMap_c.790ae545.svg";